import { cn } from '@nexo/ui';
import { BadgeCheck } from 'lucide-react';
import { useTranslation } from 'react-i18next';

/** Marks Nexo's official server. */
export function OfficialBadge({ className }: { className?: string }) {
  const { t } = useTranslation();
  return (
    <BadgeCheck
      className={cn('size-4 shrink-0 fill-accent text-surface', className)}
      aria-label={t('Servidor oficial de Nexo')}
    >
      <title>{t('Servidor oficial de Nexo')}</title>
    </BadgeCheck>
  );
}
